import React from 'react';
import options from './options';

const SnackbarContainer: React.StatelessComponent = () => <div id={options.wrapperId} />;

export default SnackbarContainer;
